export const ADD_RENEWAL_QUOTE = "ADD_RENEWAL_QUOTE";

export const SET_RENEWAL_QUOTE = "SET_RENEWAL_QUOTE";
